// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme"; // Asegúrate de que esta ruta sea correcta
import { DatosNutriologoContextProvider } from "./context/DatosNutriologoContext";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Normaliza los estilos */}
      <DatosNutriologoContextProvider>
        <App />
      </DatosNutriologoContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);
